import SwivuSettingsTagValueTabBase from "./SwivuSettingsTagValueTabBase.jsx";
import { TAGS_KEYS } from "../../../other/constants/TagsKeys.jsx";
import { STORE_KEYS } from "../../../other/constants/StoreKeys.jsx";
import {GRANTS} from "../../../other/constants/PrivilegeTypes.jsx";
import {SETTING_TAB_WIDGET_KEYS} from "../../../other/constants/OtherKeys.jsx";

const GRID_KEYS = {
  categoryGrid: "contactCategoriesGrid",
};

export default class SwivuSettingsContactCategoryTab extends SwivuSettingsTagValueTabBase {
  static get $name() {
    return "SwivuSettingsContactCategoryTab";
  }

  static get type() {
    return "swivusettingscontactcategorytab";
  }

  get swivuDeepLinkSlug() {
    return SETTING_TAB_WIDGET_KEYS.contactCategoryTab;
  }

  getStoreName() {
    return STORE_KEYS.contactTagValuesStore;
  }

  getTagKeysWithWidgetRef() {
    return {
      [TAGS_KEYS.category]: GRID_KEYS.categoryGrid,
    };
  }

  swivuCheckGrants(user) {
    if (!user.can(GRANTS.grant_one)) {
      const grid = this.widgetMap[GRID_KEYS.categoryGrid];
      grid.disabled = true;
      grid.readOnly = true; // readonly will prevent row reorder
      grid.bbar.items.forEach(
        (item) => (item.disabled = true)
      );
    }
  }

  static get configurable() {
    return {
      title: "Contacts",
      scrollable: true,
      ...SwivuSettingsTagValueTabBase.getDefaultLayoutSettings(),
      items: {
        [GRID_KEYS.categoryGrid]: SwivuSettingsTagValueTabBase.getGridWidget({
          headerText: "Contact Categories",
          defaultValue: "Enter Category"
        }),
      }
    };
  }
}

SwivuSettingsContactCategoryTab.initClass();
